import React from 'react';
import Twoplateni from './Twoplateni';
import Hotselling from './Hotselling';
import Qualitymeets from './Qualitymeets';
import Movableplaten from './Movableplaten';
import Quickmold from './Quickmold';
import Easymaintenance from './Easymaintenance';
import Autoparts from './Autoparts';
import Partners from './Partners';



const Dpseriest = () => {
  return (
    <div>
      <Twoplateni />
      <Hotselling />
      <Qualitymeets />
      <Movableplaten />
      <Quickmold />
      < Easymaintenance />
      < Autoparts />
      <Partners />
    </div>
  );
};

export default Dpseriest;
